module.exports = __webpack_public_path__ + "static/29-b31cc08439cadb65eae6d689c9bcc8b1.jpg";